<template>
  <div class="loginLsContain">
    <div class="logo-container">
      <div class="logo">
        <div class="title">
          <div class="headPortrait"></div>
          <div class="MMservice"></div>
        </div>
        mm客服全智能云客服专家
      </div>
    </div>
    <div class="outer-container">
      <el-form label-position="left"  :model="formls" ref="formls" label-width="0px" class="demo-ruleForm login-container">
        <h3 class="title">MM客服系统运营管理后台</h3>
        <el-form-item prop="user">
          <span>帐号</span>
          <el-input class="account" type="text" auto-complete="off" v-model="formls.user" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <span>密码</span>
          <el-input class="password" type="password" auto-complete="off" v-model="formls.pass" placeholder="密码"></el-input>
          <p class="loginMessageError">{{loginMessage}}</p>
        </el-form-item>
        <div class="function">
          <div class="remember">
            <input type="checkbox" checked id="remember" @click="rememberPass">
            <label for="remember" >记住密码</label>
          </div>
        </div>
        <el-form-item style="width:100%;">
          <el-button class="button" style="width:100%;" @click="loginHome">确认</el-button>
        </el-form-item>
      </el-form>
      <m-token-dialog ref="mTokenRef" @verified="mTokenVerified"></m-token-dialog>
    </div>
  </div>
</template>


<script>
import '../../statics/css/loginLs.scss';
import qs from 'qs';
import bus from "../../common/commonVue.js";
import MTokenDialog from '../mToken/mTokenDialog.vue';
export default {
  components: { MTokenDialog },
  data() {
    return {
      formls: {
        user: window.localStorage.getItem("account") || "",
        pass: window.localStorage.getItem("password") || ""
      },
      loginMessage: "",
      rememberPassIndex:0
    }
  },
  created() {
    this.rememberPass();
    //console.log(window.localStorage.getItem("account"));
    //console.log(window.localStorage.getItem("password"));
  },
  methods: {
    loginHome() {
      this.$refs.formls.validate((valid) => {
        if (valid) {

          this.getVaMessage();
        } else {
          //console.log("err submits");
        }
      });

    },
    //获取验证信息
    getVaMessage() {

          var tz_diff = - (new Date()).getTimezoneOffset() * 60
          const loginParmas = { account: this.formls.user, password: this.formls.pass, tz_diff: tz_diff};
                  const url = "/api/sign_in/";



      this.$ajax.post(
        url,
        qs.stringify(loginParmas)
      ).then(res => {
        if (res.data.result == "ok") {
          this.finishLogin();
        } else if (res.data.result == "m_token_required") {
          this.loginMessage = "";
          this.$refs.mTokenRef.show({
            mode: 'login',
            challenge: res.data.challenge,
            account: this.formls.user
          });
        } else {
          this.showLoginError(res.data.error);
        }
      })
       //console.log(this.rememberPassIndex)

    },
    mTokenVerified(payload) {
      if (payload.mode === 'login') {
        this.finishLogin();
      }
    },
    finishLogin() {
          this.loginMessage = "";
        const storge = window.localStorage;

          window.sessionStorage.setItem("routerAcc",this.formls.user)

          if(this.rememberPassIndex % 2 == 0) {

            storge.removeItem("account");
            storge.removeItem("password");

          }else if(this.rememberPassIndex % 2 != 0) {
            storge.setItem("account",this.formls.user)
            storge.setItem("password",this.formls.pass)
              //console.log("我执行了添加");

          }
          bus.$emit("rememberpassindexmd",this.rememberPassIndex);
          this.$router.push({ path: "/enterpriseTrend" });
    },
    showLoginError(error) {
          if(this.formls.user == "" || this.formls.pass == "") {
            this.loginMessage = "帐号或密码不能为空，请输入";
                setTimeout(() => {
                  this.loginMessage = "";
                }, 1500)
          } else if (error == "auth fail") {
            this.loginMessage = "帐号或密码错误，请重新输入";
            setTimeout(() => {
              this.loginMessage = "";
            }, 1500)
          } else if (error == "already logged in") {
            this.loginMessage = "帐号正在处于登录状态，请重新确认";
            setTimeout(() => {
              this.loginMessage = "";
            }, 1500)
          } else {
            this.loginMessage = error || "登录失败，请稍后重试";
          }
    },
    rememberPass() {
      this.rememberPassIndex++;
    }
  }
}
</script>

<style lang="scss" scoped>
 .loginLsContain{
        height: 100%;
        display:flex;
        background: url('../../statics/img/loginBg.png') no-repeat center;
        background-size: 100% 66%;
        .logo-container{
            width:50%;
            display: flex;
            justify-content: center;
            align-items:center;
            .logo{
                color: #333;
                font-size:19px;
                text-align: center;
                .title{
                    display:flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom:46px;
                    .headPortrait{
                        width:62px;
                        height:48px;
                        margin-right: 26px;
                        background: url("../../statics/img/icon@2x.png") no-repeat 0 -107px;
                    }
                    .MMservice{
                        width:160px;
                        height:38px;
                        background: url("../../statics/img/icon@2x.png") no-repeat 0 -215px;
                    }
                }
            }
        }
        .outer-container{
            width:50%;
            display: flex;
            justify-content: center;
            align-items:center;
            .loginMessageError {
              position:absolute;
              left:12px;
              bottom:10px;
              color:#f76969;
              font-size:12px;
            }
            .login-container {
                margin-right: 30%;
                box-sizing: border-box;
                /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
                -webkit-border-radius: 5px;
                border-radius: 5px;
                -moz-border-radius: 5px;
                background-clip: padding-box;
                /*width:p2r(450);*/
                min-width: 450px;
                padding: 0px 44px 0px 65px;
                background: #fff;
                border: 1px solid #eaeaea;
                box-shadow: 0 0 25px #cac6c6;
                color: #999;
                .title {
                    font-size: 24px;
                    text-align: center;
                    color: #333;
                    font-weight: normal;
                    padding: 67px 0 57px 0;
                }
                .remember{
                    margin: 0px 0px 39px 0px;
                    display: flex;
                    align-items:center;
                }
                #remember {
                    margin:0 10px 14px 5px;
                }
                .account{
                    margin:10px 0 20px 0;
                }
                .password{
                    margin:10px 0 35px 0;
                }
                .function{
                    display:flex;
                    justify-content: space-between;
                    a{
                        color: #999;
                    }
                }

                .button{
                    line-height:52px;
                    background: #20a59a;
                    margin:0;
                    padding:0;
                    border:none;
                    color: #fefefe;
                    font-size:20px;
                    margin-bottom: 100px;
                    border-radius: 3px;
                    cursor:pointer;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// loginls.vue?3c1be2fe